module.exports = __webpack_public_path__ + "static/Diagnose-cd716c9d2c20140713284c04998309ec.jpg";